// extracted by mini-css-extract-plugin
export default {"form":"Form_form__tXRif","form__row":"Form_form__row__Ht60Q"};